import React, { useContext } from 'react';

import ChatChannelListContext from '../../../context/ChatChannelListContext';
import { ChannelBuckets, channelBucketsConfig } from '../../../utils/channelBuckets';
import { usePostHog } from '../../../hooks/usePostHog';

import { StyledTabComponent } from './styles';

const ChannelBucketSelect = () => {
  const {
    selectedBucket,
    setSelectedBucket,
    pendingChannelCount,
  } = useContext(ChatChannelListContext);

  const { isAIFriendEnabled } = usePostHog();

  const tabsConfig = Object.keys(ChannelBuckets).reduce((acc, bucket) => {
    // Hide AI Friend bucket if AI Friend is not enabled in posthog feature flag
    if (bucket === ChannelBuckets.AI_FRIEND && !isAIFriendEnabled()) {
      return acc;
    }

    acc[bucket] = {
      label: channelBucketsConfig[bucket].label,
      ...(bucket === ChannelBuckets.DRAFT && pendingChannelCount && { count: pendingChannelCount }),
    };
    return acc;
  }, {});

  return (
    <StyledTabComponent
      tabsConfig={tabsConfig}
      selectedTab={selectedBucket}
      onSelectTab={(bucket) => setSelectedBucket(bucket)}
    />
  );
};

export default ChannelBucketSelect;
